<template>
    <div class="rzy-page">

        <div class="rzy-top-bar">
			<el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="请输入关键字" 
			clearable @select="handleSelect"></el-autocomplete>
			<el-button type="primary" @click="initPrint('localListTableId')" style="margin-left: 10px;" size="default" icon="el-icon-printer">打印
			</el-button>
        </div>

		<div id="localListTableId">
        <el-table :data="responseData" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle" 
            border stripe  @selection-change="handleSelectionChange">

            <el-table-column sortable prop="materialName" label="物料名称">
            </el-table-column>
            <el-table-column sortable prop="materialNumber" label="物料编号">
            </el-table-column>
            <el-table-column sortable prop="count" label="数量(匹)">
            </el-table-column>
            <el-table-column sortable prop="productLength" label="米数(米)">
            </el-table-column>
            <el-table-column sortable prop="productWeight" label="过磅重量(千克)">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="goToPeiBuDetails(scope.row.materialName,scope.row.materialNumber,scope.row.materialId)">详情</el-link>
                </template>   
            </el-table-column>
        </el-table>
		</div>

        <el-pagination style="text-align: center;margin-top: 10px;" background layout="prev, pager, next"
            @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>

    </div>
</template>

<script>
    import {
        peiBuDetails,
        dQueryInput
    } from '@/components/projectComponents'
	import { pbkdf2 } from 'crypto'
	import printJS from 'print-js'

    export default {
        components: {
            dQueryInput
        },
        data() {
            return {
                //分页 -- sta
                pageInfo: {
                    page: 1,
                    size: 15,
                    
                },
                totalPages: 0,
                //分页 -- end


                //日期范围选择控件 -- sta
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);

                        }
                    }]
                },
                daterangeSelectResult: '', //日期范围 选择的结果
                //日期范围选择控件 -- end

                responseData: [
                    // 调试用假数据--正式版注释掉
                    
                ],
				state: '',
            }
        },
        methods: {

            // 分页切换
            handleCurrentChange(newNum) {
                this.getPeiBuList(newNum)
            },

            // 日期范围选择控件，内容改变事件
            daterangeSelectChange() {
                // console.log('daterangeSelectResult=', this.daterangeSelectResult)
                // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
                // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

                //开始时间 转 时间戳
                let m_date = new Date(this.daterangeSelectResult[0]);
                let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                this.pageInfo.startTime = m_time
                // console.log('startTime=', this.pageInfo.startTime)

                //结束时间 转 时间戳
                m_date = new Date(this.daterangeSelectResult[1]);
                m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                this.pageInfo.endTime = m_time
                // console.log('endTime=', this.pageInfo.endTime)

                this.refreshPage()
            },

            // 刷新
            refreshPage() {
                this.getList(1)
                this.$Message.success('刷新成功')
            },

            // 条件查询
            queryBySelect(pageInfo) {
				console.log(pageInfo)
                this.pageInfo = pageInfo
                this.getList(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.getList(1)
            },

            // 获取XX分页列表
            getList(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: 'v1/stock/list/material',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化XX列表
            formatResponse(response) {
                response.forEach((item, index) => {
					item.productLength = (Number(item.productLength)/100).toFixed(2)
					item.productWeight = (Number(item.productWeight)/1000).toFixed(2)
                })
                return response
            },
            // 弹出物料对应的库存信息
            goToPeiBuDetails(name, number, id) {
                this.$router.push({
                    path: 'inventoryofmaterialDetails',
                    query: {
                        materialNumber: number,
                        materialName: name,
						materialId: id
                    }
                });
            },
			
			querySearchAsync(queryString,cb) {
				console.log(queryString);
				this.pageInfo = this.getpageInfo(queryString)
				this.getList(1)
				cb([])
			},
			createStateFilter(queryString) {
				return (state) => {
					return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				console.log(item);
			},
			getpageInfo(Name){
				return {
					page: 1,
                    size: 15,
					materialName: Name,
				}
			},
			setCellStyle({ row, column, rowIndex, columnIndex }) {
				  
			      let that = this;
			      let columns = [1,2,3,4,5]; //想要改变列的索引
			      if (columns.indexOf(columnIndex) > -1) { //有出现的话就返回center
			        return "text-align:center;";
			      } else {
			        return "text-align:left;padding-left:15px;"; //没有的话就返回left
			    }
			},
			setHeaderCellStyle({ row, column, rowIndex, columnIndex }) {		  
			      let that = this;
			      let columns = [1,2,3,4,5]; //想要改变列的索引
			      if (columns.indexOf(columnIndex) > -1) { //有出现的话就返回center
			        return "text-align:center;";
			      } else {
			        return "text-align:left;padding-left:15px;"; //没有的话就返回left
			    }
			},
			// 在打印当前报表前，拼接title
			initPrint(id) {
				printJS({
					// printable: 'pageDetail', type: 'html', targetStyles: ['*'], maxWidth: 1100, scanStyles: true
					printable: id, 
					type: 'html', 
					targetStyles: ['*'], 
					maxWidth: 1100, 
					scanStyles: true,
					header: '物料明细',
					           // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
					           //  thead th {
					           //    border-top: 2px solid #000;
					           //    border-right: 2px solid #000;
					           //    border-left: 2px solid #000;
					           //  }
					           //  tbody td {
					           //    border: 2px solid #000;
					           //  }
					           //  tbody {
					           //    text-align: center;
					           //  }
					           //  table {
					           //    border-collapse: collapse;
					           //  }`,					
				})
				return
			    this.utils.printTable(id, `物料明细`)
				
			},
        },
        created() {},
        mounted() {
            this.getList(1)
			
        },
    }
</script>

<style scoped lang="scss">

</style>
